import gsap from 'gsap';
import {
    CircleBufferGeometry, Group,
    Mesh
} from 'three';
import { /* SIZE_REFS_MAP, */ SIZE_OPTIONS, SIZE_REFS_MAP } from '../../../constants/sizes';
import { MaterialsFactory } from '../factories/MaterialsFactory';
import { materialsLib } from '../../../../data/settings';
import { ButtonComponent3D } from './ButtonComponent3D';
import { QuizActionType } from '../../../constants/QuizActionEvent';

export class ShareButton extends ButtonComponent3D {
    #rootG;
    #circleMesh;
    #radiusInitial = 1;
    #radius = 1;

    constructor(social, label) {
        super({
            type: QuizActionType.SHARE,
            social,
            label
        });

        const { shareButton } = SIZE_REFS_MAP[SIZE_OPTIONS.LANDSCAPE];

        this.#radiusInitial = shareButton.radius;
        this.#radius = shareButton.radius;

        const rootG = new Group();
        const geom = new CircleBufferGeometry(
            shareButton.radius, 24
        );
        const circleMesh = new Mesh(geom, MaterialsFactory.create(materialsLib.shareButtonBasic[social] || {}));

        circleMesh.position.z = -0.02;

        rootG.scale.set(1.01, 1.01, 1.01);

        rootG.add(circleMesh);
        this.add(rootG);

        this.#rootG = rootG;
        this.#circleMesh = circleMesh;
        this._mainClickTarget = circleMesh;
    }

    _setup() {
        super._setup();
        this.waitForPreload = true;
        this.hasResize = true;
        this.hasStart = true;
        this.clickable = true;
    }

    _resize(winWidth, winHeight, orientation, orientationChanged, changed, pixelRatio) {
        super._resize(winWidth, winHeight, orientation, orientationChanged, changed, pixelRatio);

        if (orientationChanged) {
            const { shareButton } = SIZE_REFS_MAP[orientation];

            this.#radius = shareButton.radius;
            const s = shareButton.radius / this.#radiusInitial;

            this.#rootG.scale.set(s, s, s);
        }
    }

    get radius() {
        return this.#radius;
    }

    get height() {
        return this.#radius;
    }

    setOver() {
        if (!this.visible) return;

        gsap.to(this.#circleMesh.scale, {
            x: 1.1,
            y: 1.1,
            duration: 0.45,
            ease: 'elastic.out(1, 0.5)',
            overwrite: 'auto'
        });
    }

    setOut() {
        if (!this.visible) return;

        gsap.to(this.#circleMesh.scale, {
            x: 1,
            y: 1,
            duration: 0.35,
            ease: 'elastic.out(1, 0.75)',
            overwrite: 'auto'
        });
    }
}
